<template>
  <svg
    viewBox="0 0 512 512"
    class="c-icon"
    aria-hidden="true"
    :class="{
      '-shadow': shadow,
      '-spinning': spinning,
      '-huge': huge,
      '-large': large,
      '-larger': larger,
      '-medium': medium,
      '-small': small,
      '-tiny': tiny,
      '-mirrored': mirrored,
      '-rotate-90': rotate90,
      '-inWhiteCircle': inWhiteCircle,
      '-gray': gray,
    }"
    focusable="false">
    <use :xlink:href="xlink" />
  </svg>
</template>

<script>
import { useTextDirection } from '@vueuse/core'

export default {
  props: {
    type: {
      required: true,
      type: String,
    },
    spinning: {
      default: false,
      type: Boolean,
    },
    huge: {
      required: false,
      type: Boolean,
    },
    large: {
      required: false,
      type: Boolean,
    },
    larger: {
      required: false,
      type: Boolean,
    },
    medium: {
      required: false,
      type: Boolean,
    },
    small: {
      required: false,
      type: Boolean,
    },
    tiny: {
      required: false,
      type: Boolean,
    },
    mirrored: {
      required: false,
      type: Boolean,
    },
    rotate90: {
      required: false,
      type: Boolean,
    },
    inWhiteCircle: {
      required: false,
      type: Boolean,
    },
    gray: {
      required: false,
      type: Boolean,
    },
    shadow: {
      required: false,
      type: Boolean,
    },
  },
  computed: {
    xlink() {
      return `/img/icons.svg#${this.computedType}`
    },
    computedType() {
      const aliases = {
        type_document_word: 'type_document',
        type_document_image: 'type_document',
        type_document_pdf: 'type_document',
        type_document_powerpoint: 'type_document',
      }
      const baseType = typeof aliases[this.type] !== 'undefined' ? aliases[this.type] : this.type
      const textDirection = useTextDirection()
      const isRTL = textDirection.value === 'rtl'
      if (isRTL) {
        const swap = {
          arrow_left: 'arrow_right',
          arrow_right: 'arrow_left',
          chevron_left: 'chevron_right',
          chevron_right: 'chevron_left',
        }
        if (typeof swap[baseType] !== 'undefined') {
          return swap[baseType]
        }
      }
      return baseType
    },
  },
}
</script>
